import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=6669c546&scoped=true&"
import script from "./InfoTab.vue?vue&type=script&lang=js&"
export * from "./InfoTab.vue?vue&type=script&lang=js&"
import style0 from "./InfoTab.vue?vue&type=style&index=0&id=6669c546&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6669c546",
  null
  
)

export default component.exports